import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer">
      <Link to={"/"}>
        <h2>Nc-News-2022</h2>
      </Link>
    </div>
  );
};

export default Footer;
